import { render, staticRenderFns } from "./WarehouseTabTransaction.vue?vue&type=template&id=f0104c5c"
import script from "./WarehouseTabTransaction.vue?vue&type=script&lang=js"
export * from "./WarehouseTabTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports